import {
  App,
  Modal as StaticModal,
  message as staticMessage,
  notification as staticNotification,
} from 'antd';
import type { ModalStaticFunctions } from 'antd/es/modal/confirm';

/** antd <App> 提供的实例类型，跟随 antd 版本自动对齐 */
type FeedbackInstance = ReturnType<typeof App.useApp>;

let instance: FeedbackInstance | null = null;

/** 由 AppProvider 内的 FeedbackBridge 注入 antd App 实例 */
export const bindFeedback = (next: FeedbackInstance) => {
  instance = next;
  return () => {
    if (instance === next) instance = null;
  };
};

/**
 * 全局反馈（对应 vue-naive-admin 里的 $message / $dialog）
 *
 * 优先使用 antd <App> 提供的实例，这样弹层能拿到 ConfigProvider 的主题与语言；
 * 未挂载时消息与通知可用静态方法；确认弹窗必须等待反馈桥就绪，以统一使用 BaseConfirm。
 */
export const feedback = {
  get message() {
    return instance?.message ?? staticMessage;
  },
  get notification() {
    return instance?.notification ?? staticNotification;
  },
  get modal(): FeedbackInstance['modal'] | ModalStaticFunctions {
    if (instance) return instance.modal;
    return {
      ...StaticModal,
      confirm: () => {
        throw new Error('确认弹窗尚未挂载，请在 AppProvider 就绪后调用');
      },
    };
  },
};
